export default __webpack_public_path__ + "static/allProjects7-c20af71a63dec8c9c9fd85ce2f10c22d.png";